module.exports = __webpack_public_path__ + "static/media/dismiss.a017534b.svg";